import { GET_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetAndroidConfig = () =>
    GET_ENC(`${BASE_URL}/api/Configuration/GetAppDetails`, null);